var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"text-align":"center","margin":"8px"}},[_c('v-img',{class:{ spin: true },staticStyle:{"display":"inline-block"},attrs:{"src":require('../../assets/TBDC_icon_grey.svg'),"width":"32","height":"32"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }